import DemoBanner from "./DemoBanner";
import { Clock, MapPin, Phone, Scissors } from "lucide-react";

const services = [
  { name: "Classic Cut", price: "$40", desc: "Precision scissor or clipper cut, finished with a hot towel." },
  { name: "Skin Fade", price: "$45", desc: "Sharp zero-guard fade blended to perfection." },
  { name: "Beard Sculpt", price: "$25", desc: "Line-up, shape, and trim. Hot lather finish." },
  { name: "Cut + Beard", price: "$60", desc: "The full treatment — fresh cut and a sculpted beard." },
  { name: "Straight Razor Shave", price: "$35", desc: "Old-school straight razor with hot towels and balm." },
  { name: "Kids Cut (12 & Under)", price: "$25", desc: "Same quality, just smaller." },
];

const barbers = [
  {
    name: "Marcus Cole",
    role: "Owner / Lead Barber",
    bio: "18 years behind the chair. Specializes in fades and textured cuts.",
    image: "https://images.unsplash.com/photo-1595790753283-3c164baddb72?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxiYXJiZXIlMjBwb3J0cmFpdCUyMGhlYWRzaG90JTIwbWFsZSUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzYyODgxNTh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Jay Delgado",
    role: "Senior Barber",
    bio: "12 years. Known for razor-sharp line-ups and classic tapers.",
    image: "https://images.unsplash.com/photo-1709675155252-f00141380412?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwzfHxiYXJiZXIlMjBwb3J0cmFpdCUyMGhlYWRzaG90JTIwbWFsZSUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzYyODgxNTh8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    name: "Deon Harper",
    role: "Barber",
    bio: "6 years. Creative cuts, designs, and always a good conversation.",
    image: "https://images.unsplash.com/photo-1720251354355-258ad9d1a6af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwyfHxiYXJiZXIlMjBwb3J0cmFpdCUyMGhlYWRzaG90JTIwbWFsZSUyMHByb2Zlc3Npb25hbHxlbnwwfHx8fDE3NzYyODgxNTh8MA&ixlib=rb-4.1.0&q=85",
  },
];

const hours = [
  { day: "Monday", time: "Closed" },
  { day: "Tuesday", time: "9:00 AM – 7:00 PM" },
  { day: "Wednesday", time: "9:00 AM – 7:00 PM" },
  { day: "Thursday", time: "9:00 AM – 8:00 PM" },
  { day: "Friday", time: "9:00 AM – 8:00 PM" },
  { day: "Saturday", time: "8:00 AM – 6:00 PM" },
  { day: "Sunday", time: "10:00 AM – 4:00 PM" },
];

export default function IronIvory() {
  return (
    <div data-testid="demo-iron-ivory" style={{ fontFamily: "'DM Sans', sans-serif" }} className="bg-[#0F0F0F] text-[#F5F0E0] min-h-screen">

      {/* Hero */}
      <section className="relative h-screen min-h-[600px] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://images.unsplash.com/photo-1572663459735-75425e957ab9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxkYXJrJTIwbW9vZHklMjBiYXJiZXJzaG9wJTIwaW50ZXJpb3IlMjB2aW50YWdlfGVufDB8fHx8MTc3NjI4ODE1Mnww&ixlib=rb-4.1.0&q=85"
            alt="Iron & Ivory Barbershop interior"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/60" />
        </div>

        <div className="relative z-10 text-center px-6 max-w-3xl">
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="h-px w-12 bg-[#D4803B]" />
            <span className="text-[#D4803B] text-xs uppercase tracking-[0.35em] font-semibold">Est. 2016 &middot; Oakland, CA</span>
            <div className="h-px w-12 bg-[#D4803B]" />
          </div>

          <h1 style={{ fontFamily: "'Bodoni Moda', serif" }} className="text-5xl sm:text-7xl lg:text-8xl font-bold leading-[0.95] tracking-tight">
            Iron <span className="text-[#D4803B]">&</span> Ivory
          </h1>
          <p style={{ fontFamily: "'Bodoni Moda', serif" }} className="text-xl sm:text-2xl italic text-[#F5F0E0]/60 mt-3 tracking-wide">
            Barbershop
          </p>

          <p className="text-[#F5F0E0]/50 mt-8 max-w-md mx-auto leading-relaxed text-sm sm:text-base">
            A neighborhood barbershop built on craft, conversation, and the belief that a great cut changes how you carry yourself.
          </p>

          <button onClick={() => document.getElementById('contact')?.scrollIntoView({behavior:'smooth'})} className="mt-10 bg-[#D4803B] text-[#0F0F0F] px-10 py-4 text-sm uppercase tracking-widest font-bold hover:bg-[#F5F0E0] transition-colors">
            Book Your Chair
          </button>
        </div>

        {/* Scroll hint */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2">
          <div className="w-px h-10 bg-[#F5F0E0]/20" />
          <span className="text-[#F5F0E0]/30 text-[10px] uppercase tracking-[0.3em]">Scroll</span>
        </div>
      </section>

      {/* Divider detail */}
      <div className="flex items-center justify-center py-8">
        <div className="h-px w-16 bg-[#D4803B]/30" />
        <Scissors size={16} className="text-[#D4803B]/40 mx-4 rotate-90" />
        <div className="h-px w-16 bg-[#D4803B]/30" />
      </div>

      {/* Services */}
      <section className="max-w-2xl mx-auto px-6 py-16 md:py-24">
        <div className="text-center mb-16">
          <span className="text-[#D4803B] text-xs uppercase tracking-[0.35em] font-semibold">Services</span>
          <h2 style={{ fontFamily: "'Bodoni Moda', serif" }} className="text-4xl sm:text-5xl font-bold mt-3">
            What We Do
          </h2>
        </div>

        <div className="space-y-0">
          {services.map((s, i) => (
            <div key={s.name} className={`flex items-baseline justify-between py-6 ${i < services.length - 1 ? 'border-b border-[#F5F0E0]/10' : ''}`}>
              <div className="flex-1 pr-6">
                <h3 className="text-lg font-semibold text-[#F5F0E0]">{s.name}</h3>
                <p className="text-sm text-[#F5F0E0]/40 mt-1">{s.desc}</p>
              </div>
              <span style={{ fontFamily: "'Bodoni Moda', serif" }} className="text-2xl font-bold text-[#D4803B] flex-shrink-0">
                {s.price}
              </span>
            </div>
          ))}
        </div>
      </section>

      {/* Photo break */}
      <div className="relative h-64 md:h-80 overflow-hidden">
        <img
          src="https://images.unsplash.com/photo-1662123844664-7235ecbb4e53?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxiYXJiZXIlMjBjdXR0aW5nJTIwaGFpciUyMGNsb3NlJTIwdXAlMjBtb29keSUyMGxpZ2h0aW5nfGVufDB8fHx8MTc3NjI4ODIwNXww&ixlib=rb-4.1.0&q=85"
          alt="Barber at work"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0F0F0F] via-transparent to-[#0F0F0F]" />
      </div>

      {/* The Barbers */}
      <section className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <div className="text-center mb-16">
          <span className="text-[#D4803B] text-xs uppercase tracking-[0.35em] font-semibold">The Team</span>
          <h2 style={{ fontFamily: "'Bodoni Moda', serif" }} className="text-4xl sm:text-5xl font-bold mt-3">
            Meet the Barbers
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-10 sm:gap-8">
          {barbers.map((b) => (
            <div key={b.name} className="text-center group">
              <div className="w-36 h-36 mx-auto rounded-full overflow-hidden border-2 border-[#D4803B]/30 group-hover:border-[#D4803B] transition-colors">
                <img
                  src={b.image}
                  alt={b.name}
                  className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                />
              </div>
              <h3 style={{ fontFamily: "'Bodoni Moda', serif" }} className="text-xl font-bold mt-5">
                {b.name}
              </h3>
              <p className="text-[#D4803B] text-xs uppercase tracking-widest font-semibold mt-1">{b.role}</p>
              <p className="text-[#F5F0E0]/40 text-sm mt-2 leading-relaxed">{b.bio}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Divider */}
      <div className="flex items-center justify-center py-4">
        <div className="h-px w-16 bg-[#D4803B]/30" />
        <Scissors size={16} className="text-[#D4803B]/40 mx-4 rotate-90" />
        <div className="h-px w-16 bg-[#D4803B]/30" />
      </div>

      {/* Location & Hours */}
      <section className="max-w-3xl mx-auto px-6 py-16 md:py-24">
        <div className="text-center mb-16">
          <span className="text-[#D4803B] text-xs uppercase tracking-[0.35em] font-semibold">Visit</span>
          <h2 style={{ fontFamily: "'Bodoni Moda', serif" }} className="text-4xl sm:text-5xl font-bold mt-3">
            Find Us
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-12">
          {/* Map */}
          <div>
            <div className="aspect-square rounded overflow-hidden border border-[#F5F0E0]/10">
              <iframe
                title="Iron & Ivory location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d50464.86030504307!2d-122.27085935!3d37.8043637!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80857d8b28aaed03%3A0x71b415d535759367!2sOakland%2C%20CA!5e0!3m2!1sen!2sus!4v1700000000000!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0, filter: "invert(90%) hue-rotate(180deg) saturate(0.3)" }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              />
            </div>
            <div className="mt-4 flex items-start gap-3">
              <MapPin size={16} className="text-[#D4803B] flex-shrink-0 mt-1" />
              <p className="text-sm text-[#F5F0E0]/60">2847 Telegraph Ave, Oakland, CA 94609</p>
            </div>
            <div className="mt-2 flex items-start gap-3">
              <Phone size={16} className="text-[#D4803B] flex-shrink-0 mt-1" />
              <p className="text-sm text-[#F5F0E0]/60">(510) 555-0147</p>
            </div>
          </div>

          {/* Hours */}
          <div>
            <div className="flex items-center gap-2 mb-6">
              <Clock size={16} className="text-[#D4803B]" />
              <h3 className="text-sm uppercase tracking-widest font-semibold text-[#F5F0E0]/80">Hours</h3>
            </div>
            <div className="space-y-0">
              {hours.map((h) => (
                <div key={h.day} className="flex items-center justify-between py-3 border-b border-[#F5F0E0]/5">
                  <span className="text-sm text-[#F5F0E0]/60">{h.day}</span>
                  <span className={`text-sm font-medium ${h.time === 'Closed' ? 'text-[#F5F0E0]/25' : 'text-[#F5F0E0]/80'}`}>
                    {h.time}
                  </span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section id="contact" className="py-20 md:py-28 px-6 text-center border-t border-[#F5F0E0]/5">
        <h2 style={{ fontFamily: "'Bodoni Moda', serif" }} className="text-3xl sm:text-4xl lg:text-5xl font-bold">
          Your chair is waiting.
        </h2>
        <p className="text-[#F5F0E0]/40 mt-4 max-w-sm mx-auto text-sm leading-relaxed">
          Walk-ins welcome. Appointments guaranteed. Book online or give us a call.
        </p>
        <button onClick={() => document.getElementById('contact')?.scrollIntoView({behavior:'smooth'})} className="mt-8 bg-[#D4803B] text-[#0F0F0F] px-12 py-4 text-sm uppercase tracking-widest font-bold hover:bg-[#F5F0E0] transition-colors">
          Book Now
        </button>
      </section>

      {/* Footer */}
      <footer className="border-t border-[#F5F0E0]/5 py-8 px-6 text-center">
        <span style={{ fontFamily: "'Bodoni Moda', serif" }} className="text-[#F5F0E0]/15 text-sm italic">
          {new Date().getFullYear()} Iron & Ivory Barbershop. All rights reserved.
        </span>
      </footer>

      <div className="pb-16" />
      <DemoBanner />
    </div>
  );
}
